module.exports = __webpack_public_path__ + "img/check-circle.d9d9a159.svg";